import { AttachmentPreviewMethod, AttachmentSelectionSource } from 'owa-attachment-data';
import { SaveToCloudStatus } from 'owa-attachment-savetocloud';
import EventEmitter from 'owa-event-emitter';
import { MeetingMessageAddToCalendarStatus } from 'owa-meeting-message-utils';
import GetAttachmentTextPreviewReadMode from 'owa-service/lib/contract/GetAttachmentTextPreviewReadMode';
import getInitialSxSViewState from 'owa-sxsdata/lib/utils/getInitialSxSViewState';
import { createStore } from 'satcheljs';
import { EditMode } from './schema/SxSEditState';
import { SxSStoreData, SxSStore, SXSID_MAIN_WINDOW } from './schema/SxSStore';
import { ObservableMap } from 'mobx';

function createInitialStoreData(): SxSStoreData {
    const initialStoreData: SxSStoreData = {
        shouldShow: false,
        viewState: getInitialSxSViewState(),
        extendedViewState: {
            previewMode: AttachmentPreviewMethod.Unsupported,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (21,13): Type 'null' is not assignable to type 'ClientAttachmentId'.
            // @ts-expect-error
            attachmentId: null,
            selectionSource: AttachmentSelectionSource.MailList,
            isCloudy: false,
            saveToCloudStatus: SaveToCloudStatus.disabled,
            textPreviewReadMode: GetAttachmentTextPreviewReadMode.AutoDetect,
        },
        editState: {
            mode: EditMode.View,
            editAllowed: false,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (33,13): Type 'null' is not assignable to type 'ClientItemId'.
            // @ts-expect-error
            itemId: null,
            isDraft: false,
        },
        customPreviewState: null,
        eventManager: new EventEmitter(),
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (41,9): Type 'null' is not assignable to type 'PendingOperationState'.
        // @ts-expect-error
        pendingPreviewOperation: null,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (45,9): Type 'null' is not assignable to type '{ toAttachmentId: ClientAttachmentId; triggerTime: number; }'.
        // @ts-expect-error
        pendingNavigation: null,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (49,9): Type 'null' is not assignable to type 'SxSReadingPaneState'.
        // @ts-expect-error
        readingPaneState: null,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (53,9): Type 'null' is not assignable to type 'string'.
        // @ts-expect-error
        composeId: null,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (57,9): Type 'null' is not assignable to type 'SxSCustomization'.
        // @ts-expect-error
        customization: null,
        isInvisible: true,
        shouldUseFakeRightHandSide: false,
        isUsingFakeRightHandSide: false,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (64,9): Type 'null' is not assignable to type 'string'.
        // @ts-expect-error
        attachmentViewStateIdFromListView: null,
        sessionPreviewCount: 0,
        sessionStartTime: 0,
        meetingMessageAddToCalendarStatus: MeetingMessageAddToCalendarStatus.Available,
        sigsInfo: null,
    };
    initialStoreData.viewState.previewPane = null;
    return initialStoreData;
}

const defaultStore: SxSStore = {
    sxsStoreMapping: new ObservableMap<string, SxSStoreData>({}),
};
const store = createStore<SxSStore>('sxsStore', defaultStore)();
export const getStore = () => store;

export default function getOrCreateSxSStoreData(sxsId?: string): SxSStoreData {
    sxsId = sxsId || SXSID_MAIN_WINDOW;
    if (!store.sxsStoreMapping.has(sxsId)) {
        const initialStoreData: SxSStoreData = createInitialStoreData();
        store.sxsStoreMapping.set(sxsId, initialStoreData);
    }
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (88,5): Type 'SxSStoreData | undefined' is not assignable to type 'SxSStoreData'.
    // @ts-expect-error
    return store.sxsStoreMapping.get(sxsId);
}
